import { useCallback } from 'react';
import { FormField, TextCheckbox } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useFormValidatedValue } from 'modules/taboola-common-frontend-modules/validations';
import styles from './fetchEntityCheckBox.module.scss';

export const FetchEntityCheckBox = () => {
    const { value: fetchEntity, onChange } = useFormValidatedValue({
        field: 'fetchEntity',
    });

    const onSelect = useCallback(() => onChange(true), [onChange]);
    const onUnSelect = useCallback(() => onChange(false), [onChange]);

    return (
        <FormField inputId="fetch-entity-checkbox" containerClass={styles['field-container']}>
            <TextCheckbox
                value={fetchEntity}
                title={<FormattedMessage id="push-api.subscription.fetch.entity.title" defaultMessage="Fetch Entity" />}
                onChange={onSelect}
                onSelectCheckbox={onSelect}
                onUnselectCheckbox={onUnSelect}
                selectedValues={[true]}
                independent
            />
        </FormField>
    );
};
